import bind from 'bind-decorator';
import { Logger } from '@egr/xbox/utils/errors/Logger';
import { Lock } from '@egr/wcf/modules/utils/async';
import events from '../WebAction';

export class WebSocketConnection {
    private socket: WebSocket;
    private connectionLock: Lock = new Lock();

    public constructor(public readonly url: string, protected messageHandler: (event: MessageEvent) => void) {
        void this.connect();

        events.synchronize.addListener(async (action) => {
            if (action === 'foreground') {
                void this.connect();
            }
        });
    }

    @bind
    public async send(data: string | ArrayBuffer | Blob): Promise<void> {
        if (this.connectionLock.isLocked) {
            await this.connectionLock.waitWhileLocked();
        }

        this.socket.send(data);
    }

    @bind
    private async connect(): Promise<void> {
        const lockContext = await this.connectionLock.acquireLock();

        this.socket = new WebSocket(this.url);
        this.socket.binaryType = 'arraybuffer';

        const onOpen: VoidFunction = (): void => {
            this.socket.removeEventListener('open', onOpen);
            lockContext.unlock();
        };

        this.socket.addEventListener('open', onOpen);
        this.socket.addEventListener('close', this.connect);
        this.socket.addEventListener('message', this.onMessage);
        this.socket.addEventListener('error' , this.onError);
    }

    @bind
    private onMessage(event: MessageEvent): void {
        this.messageHandler(event);
    }

    @bind
    private onError(error: Event): void {
        Logger.error(error);
        // reconnect
        void this.connect();
    }
}
